import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/apiClient";
import { captureRef } from "@/lib/referral";
import { XcelioMark } from "@/pages/Gift";
import FoundingBadge from "@/components/partner/FoundingBadge";

// Public page: a line from a member's Coach conversation, with his referral code.
export default function Moment() {
  const { mid } = useParams();
  const [m, setM] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { captureRef(); api.get(`/moment/${mid}`).then((r) => setM(r.data)).catch(() => setFailed(true)); }, [mid]);

  if (failed) return <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center" data-testid="moment-error"><XcelioMark /><p className="text-muted-foreground">This moment isn't available any more.</p><Link to="/" className="text-primary">Discover Xcelio</Link></div>;
  if (!m) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  return (
    <div className="min-h-screen bg-background flex flex-col items-center px-5 py-10" data-testid="moment-page">
      <XcelioMark />
      <p className="text-[10px] uppercase tracking-[0.3em] text-primary mt-8" data-testid="moment-from">{m.from ? `${m.from} shared a moment from his coach` : "A moment from Xcelio"}</p>
      {m.founding && <FoundingBadge className="mt-3" />}
      <motion.figure initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="relative w-full max-w-lg mt-6 rounded-3xl border border-white/10 bg-gradient-to-br from-primary/[0.08] via-card/40 to-transparent p-8 sm:p-10 overflow-hidden">
        <span className="absolute -top-6 left-5 font-serif text-[120px] leading-none text-primary/20 select-none">&ldquo;</span>
        <blockquote className="relative font-serif italic text-2xl sm:text-3xl leading-snug" data-testid="moment-quote">{m.quote}</blockquote>
        <figcaption className="mt-6 text-sm text-muted-foreground"><span className="inline-block w-8 h-px bg-primary align-middle mr-3" />Adelaida, Xcelio Coach</figcaption>
      </motion.figure>
      <Link to={`/register?ref=${m.code}`} className="mt-10 px-8 py-3.5 rounded-full bg-primary text-primary-foreground font-medium" data-testid="moment-cta">Meet Adelaida, free</Link>
      <p className="text-xs text-muted-foreground mt-4 max-w-xs text-center">Xcelio is a personal confidence coach for men. Don't become more impressive. Become more you.</p>
    </div>
  );
}
